module.exports = "pegasus/assets/blocks/column-8-basic.png";